import FullScreenPanel from "app/ui/FullScreenPanel";
import MenuButton from "app/ui/MenuButton";
import { useEffect } from "react";
import gameplayDemo from "app/assets/gameplay-demo.gif";

interface NewPlayerPanelProps {
  onStartTutorial: () => void;
  onSkipTutorial: () => void;
}

// This panel appears when a new player begins the game.
export default function NewPlayerPanel({
  onStartTutorial,
  onSkipTutorial,
}: NewPlayerPanelProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FullScreenPanel
      heading="Welcome to Pixellence"
      headingClassName="px-9 pb-5"
      panelClassName="md:h-auto lg:h-auto shrink"
      childDivClassName="flex-col justify-start items-center gap-2 h-full pb-5"
      hideCloseButton={true}
    >
      <img className="rounded-md shadow-md" width={250} src={gameplayDemo} />
      <div className="mt-4 flex flex-col gap-2 text-center">
        <p>
          Pixellence is a variant of the classic logic puzzles known as
          Nonograms.
        </p>
        <p>If you're new to the game, we recommend starting with a tutorial.</p>
      </div>
      <div className="grow" />
      <div // BUTTON CONTAINER
        className="flex flex-col justify-center items-center gap-4 mt-4"
      >
        <MenuButton className="max-w-none px-4" onClick={onStartTutorial}>
          Start Tutorial
        </MenuButton>
        <MenuButton
          variant="small"
          className="text-lg"
          onClick={onSkipTutorial}
        >
          Skip
        </MenuButton>
      </div>
    </FullScreenPanel>
  );
}
